class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this), { passive: true });
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: null,
        selector: '#inject_cart_items',
        // section: document.getElementById('main-cart-items').dataset.id,
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.ml_js_footer.js-contents',
      },
      // {
      //   id: 'ml_progress_cart_holder',
      //   section: document.getElementById('ml_progress_cart_holder')?.dataset.id,
      //   selector: '.js-contents'
      // },
      // {
      //   id: 'ml_freeshipping_msg',
      //   section: document.getElementById('ml_freeshipping_msg')?.dataset.section,
      //   selector: '.js-contents'
      // }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section || section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then(async (response) => {
        if(!response.ok) {
          const res = await response.json();
          throw res;
        } 
        return response.text();
      })
      .then((state) => {
        if(document.getElementById('cart-errors')) document.getElementById('cart-errors').textContent = ''

        const cart_drawer = document.getElementById('cart_drawer')
        if (cart_drawer) {
          reRenderCart(state);
        }

        window.cartStatus = "added";
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartFooter = document.getElementById('main-cart-footer');
        if (parsedState.item_count === 0) {
          const ml_progress_cart = document.getElementById('ml_progress_cart');
          if (ml_progress_cart?.dataset) ml_progress_cart.dataset.percentage = 0;

          const ml_cart_footer_content = document.getElementById("ml_cart_footer_content");
          const footerData = ml_cart_footer_content?.dataset || {};

          const ml_shipping_alert = document.querySelector('#ml_freeshipping_msg span')
          if (ml_shipping_alert)
            ml_shipping_alert.innerHTML = ml_shipping_alert.dataset.msg.replace('||amount||', footerData?.money.replace("0.00", ml_shipping_alert.dataset.amount)("0,00", ml_shipping_alert.dataset.amount) || 0)
        }

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          if (elementToReplace)
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState?.sections?.[section.section || section.id] || parsedState?.sections?.[section.id], section.selector);
        }));


        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        window.cartStatus = null;
      }).catch((e) => {
        this.querySelectorAll('.scaling-dots').forEach((overlay) => overlay.classList.add('hidden'));

        const cart_drawer = document.getElementById('cart_drawer')
        if (cart_drawer) {
          e.errors && document.getElementById('cart-errors') ? document.getElementById('cart-errors').textContent = e.errors || window.cartStrings.error : '';
          reRenderCart();
          reCalculateCartFooterHeight();
        } else {
          document.getElementById('cart-errors') ? document.getElementById('cart-errors').textContent =  window.cartStrings.error : '';
        }
        this.disableLoading();

      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .scaling-dots`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);
class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  refreshRender() {
    reRenderCart();
  }

  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.openCart(e);
    }
  }

  closeMenuDrawer(event, elementToFocus) {
    // super.closeMenuDrawer(event, elementToFocus);
    this.cartZIndexHelper(false)

    this.header?.classList.remove('menu-open');
    this.cart_overlay?.classList.remove('menu-open');
    this.mainDetailsToggle?.classList.remove('menu-opening');
    document.body.style.overflow = "";
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);

    if(document.getElementById("mobile_nav")) {
      document.getElementById("mobile_nav").style.opacity =  1;
      document.getElementById("mobile_nav").style.visibility =  "";
    }

    document.getElementById('shopify-snippet-cart')?.classList?.add("cart_force_show");
    setTimeout(() => {
      document.getElementById('shopify-snippet-cart')?.classList?.remove("cart_force_show");
    }, 500)

    if (this._progressObserver) {
      this._progressObserver.disconnect();
      this._progressObserver = null;
    }

    if(this.ml_progress_cart) this.ml_progress_cart.style.transition = "none";
    const ml_progress_cart = document.getElementById("ml_progress_cart");
    if (ml_progress_cart) ml_progress_cart.style.width = "0%";
  }

  openCart(event) {
    if (this.dataset.cartType != "drawer") return;
    
    this.cartZIndexHelper()

    this.refreshRender();
    // reCalculateCartFooterHeight();

    // console.log(summaryElement);
    this.cart_overlay = this.cart_overlay || document.getElementById('cart_overlay');
    this.header = this.header || document.getElementById('shopify-snippet-cart');
    this.meanuDrawer = this.meanuDrawer || document.getElementById('cart-drawer');
    this.mainDetailsToggle = document.getElementById('Details-cart-drawer-container')

  
    // Focus on cart drawer on opening
    setTimeout(() => {
      this.querySelector('#hiddenInput')?.focus()
    }, 100);

    if (!(this.dataset.opener == 'right' && !this.header.classList.contains("menu-drawer-right"))) {
      this.header.classList.add("menu-drawer-right");
    }
    document.documentElement.style.setProperty('--header-bottom-position', `${(parseInt(this.header.getBoundingClientRect().bottom || 0) - (this.borderOffset || 0))}px`);
    setTimeout(() => {
      this.header.classList.add('menu-open');
      this.cart_overlay.classList.add('menu-open');
      document.getElementById('shopify-snippet-cart')?.classList?.remove("cart_force_show");
    })
    document.body.style.overflow = "hidden";
    if(document.getElementById("mobile_nav")) {
      document.getElementById("mobile_nav").style.opacity =  0;
      document.getElementById("mobile_nav").style.visibility =  "hidden";
    }
    document.getElementById('shopify-snippet-cart')?.classList?.add("cart_force_show");

    this.ml_progress_cart = document.getElementById("ml_progress_cart");
    if(this.ml_progress_cart) {
      this.ml_progress_cart.style.transition = "width 0.75s ease-in-out";
      this.ml_progress_cart.style.transitionDelay = "0.5s";
      
      // check to add pulse anim
      if (this.ml_progress_cart.dataset.percentage < 100) {
        this.ml_progress_cart.classList.add("not_full");
      } else {
        this.ml_progress_cart.classList.remove("not_full");
      }
    }
    
    setTimeout(() => {
      this.mainDetailsToggle?.classList.add('menu-opening');
      if(this.ml_progress_cart) this.ml_progress_cart.style.width = this.ml_progress_cart.dataset.percentage + "%";
    });

    if(this.ml_progress_cart) {
      this._progressObserver?.disconnect();
      this._progressObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation?.attributeName == "data-percentage") {
            if (this.ml_progress_cart?.dataset.percentage < 100) {
              this.ml_progress_cart?.classList.add("not_full");
            } else {
              this.ml_progress_cart?.classList.remove("not_full");
            }
            setTimeout(() => {
              this.mainDetailsToggle?.classList.add('menu-opening');
              if (this.ml_progress_cart) this.ml_progress_cart.style.width = this.ml_progress_cart.dataset.percentage + "%";
            });
          }
        });
      });

      this._progressObserver.observe(this.ml_progress_cart, {
        attributes: true //configure it to listen to attribute changes
      });
    }

    // summaryElement.setAttribute('aria-expanded', true);
    // trapFocus(this.mainDetailsToggle, summaryElement);
    if (this.dataset.opener == 'right') document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  cartZIndexHelper(open = true) {
    const headerGroup = document.querySelectorAll('.shopify-section-group-header-group');
    let announcement_section;

    headerGroup.forEach((elem => {
      if (elem.id.includes('announcement')) {
        announcement_section = elem
      }
    }))
    
    const filterButton = document.getElementById('Filter_Mobile_btn')
    
    if (open) {
      if (announcement_section) announcement_section.style.zIndex = '1'
      if (filterButton) filterButton.style.zIndex = '1'
      return;
    } 

    if (announcement_section) announcement_section.style.zIndex = ''
    if (filterButton) filterButton.style.zIndex = ''
  }

}
customElements.define('cart-drawer', CartDrawer);

function reRenderCart(data) {
  const elmentToInject = document.getElementById("inject_cart_data");
  const comp_data = elmentToInject?.dataset;
  if (data) {
    elmentToInject?.childNodes.forEach(child => elmentToInject.removeChild(child));
    reRenderCartHelper(data, comp_data, elmentToInject);
  } else {
    if (window.cartStatus == "added") {
      elmentToInject?.childNodes.forEach(child => elmentToInject.removeChild(child));

      fetch("/cart.js", {
        method: 'GET',
        // headers: { 'Sec-Fetch-Dest': 'script', 'Sec-Fetch-Mode': 'no-cors' }
      }).then(
        response => {
          return response.text();
        }
      ).then((state) => {
        reRenderCartHelper(state, comp_data, elmentToInject);
      }).catch((e) => {
        // console.log(e);
        // this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        // document.getElementById('cart-errors').textContent = window.cartStrings.error;
      });
    } else {
      const main_cart_footer = document.getElementById("main-cart-footer");

      const cart_items = document.querySelector("cart-items");
      if (cart_items?.classList.contains("is-empty")) {
        if (!main_cart_footer.classList.contains("is-empty")) main_cart_footer.classList.add("is-empty");
      } else {
        main_cart_footer.classList.remove("is-empty");
      }

      const ml_cart_footer_content = document.getElementById("ml_cart_footer_content");
      const footerData = ml_cart_footer_content.dataset;

      // const ml_shipping_alert = document.querySelector('#ml_freeshipping_msg span')
      // if (ml_shipping_alert)
      // ml_shipping_alert.innerHTML = ml_shipping_alert.dataset.msg.replace('||amount||', footerData.money.replace("0.00", ml_shipping_alert.dataset.amount))

      setTimeout(() => {
        reCalculateCartFooterHeight();
      });
    }
  }
}

function reRenderCartHelper(state, data, elmentToInject) {

  const parsedState = JSON.parse(state);

  const drawer_cart_items = document.createElement('div');
  drawer_cart_items.className = "drawer_cart_items";

  if (parsedState?.items?.length > 0) {
    const cart = document.getElementById("cart");
    cart.classList.remove("cart__contents");

    // console.log(document.getElementsByTagName("cart-items"));
    const cart_items = document.getElementsByTagName("cart-items")[0];
    cart_items.classList.remove("is-empty");

    //show subtotal footer
    const main_cart_footer = document.getElementById("main-cart-footer");
    main_cart_footer.classList.remove("is-empty");

    // -----------------------------------------------------------------------------
    // ------------------------------ footer rerender ------------------------------
    // -----------------------------------------------------------------------------

    const ml_cart_footer_content = document.getElementById("ml_cart_footer_content");
    const footerData = ml_cart_footer_content.dataset;

    const checkout_cart_drawer = document.getElementById("checkout_cart_drawer");
    checkout_cart_drawer.disabled = false;

    const ml_cart_footer_total = document.getElementById("ml_cart_footer_total");
    // ml_cart_footer_total.innerHTML = `
    //   <h3 class="totals__subtotal">${footerData.translate_subtotal}</h3>
    //   <p class="totals__subtotal-value">${footerData.money_currency.replace("0.00", parsedState.total_price / 100)}</p>
    // `;

    ml_cart_footer_total.innerHTML = footerData.money_currency.replace("0.00", parsedState.total_price / 100).replace("0,00", parsedState.total_price / 100)

    const ml_cart_footer_discount = document.getElementById("ml_cart_footer_discount");
    if (ml_cart_footer_discount) {
      ml_cart_footer_discount.innerHTML = `
        ${parsedState.cart_level_discount_applications && parsedState.cart_level_discount_applications.size > 0 ?
          `<ul class="discounts list-unstyled" role="list" aria-label="${footerData.translate_discount}">
            ${`${parsedState.cart_level_discount_applications.map(discount => (`
              <li class="discounts__discount discounts__discount--position">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 12 12">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
                </svg>
                ${discount.title}
                (-${footerData.money.replace("0.00", discount.total_allocated_amount).replace("0,00", discount.total_allocated_amount)})
              </li>
            `))}`.replace(/,/g, "")}
          </ul>` : ''}
      `;
    }

    const ml_shipping_alert = document.querySelector('#ml_freeshipping_msg span')
    if (ml_shipping_alert) {
      const remaining = ml_shipping_alert.dataset.amount * 100 - parsedState.total_price
      if (remaining > 0) {
        ml_shipping_alert.innerHTML = ml_shipping_alert.dataset.msg.replace('||amount||', footerData.money.replace("0.00", remaining / 100).replace("0,00", remaining / 100))
      } else {
        ml_shipping_alert.innerHTML = ml_shipping_alert.dataset.freeShippingTranslate || "You got free shipping!"
      }
    }

    const ml_progress_cart = document.getElementById("ml_progress_cart");
    const temp_subtotal = Math.floor(parsedState.total_price / 100);
    let free_shipping_progress = (temp_subtotal / ml_progress_cart.dataset.threshold) * 100
    if (free_shipping_progress > 100) free_shipping_progress = 100

    ml_progress_cart.dataset.percentage = free_shipping_progress

    const ml_cart_footer_note = document.getElementById("ml_cart_footer_note");
    const cart_translate = JSON.parse(footerData.translate_cart.replace(/=>/g, ":"));
    const shipping_policy_url = "https://gemhubco.com/policies/shipping-policy";
    const link_placeholder_re = /\{\{\s*link\s*\}\}/g;
    if (parsedState.taxes_included == true) {
      if (ml_cart_footer_note) {
        ml_cart_footer_note.innerHTML = `
        ${cart_translate.taxes_included_and_shipping_policy_html.replace(link_placeholder_re, shipping_policy_url)}
      `;
      }
    } else {
      if (ml_cart_footer_note) {
        ml_cart_footer_note.innerHTML = `
        ${cart_translate.taxes_and_shipping_policy_at_checkout_html.replace(link_placeholder_re, shipping_policy_url)}
      `;
      }
    }

    reCalculateCartFooterHeight();
  }
  window.cartStatus = null;
}

function reCalculateCartFooterHeight() {
  // 16 for the extra space under the footer
  const body_cont = document.getElementById("shopify-section-main-cart-items") || document.getElementById("shopify-snippit-main-cart-items")
  const footer_cont = document.getElementById("cart_footer_holder");
  const ml_cart_header = document.getElementById("ml_cart_header");
  const footer_height = footer_cont.clientHeight || 130;
  const header_height = ml_cart_header.clientHeight || 80;

  body_cont.style.height = `calc(100dvh - ${footer_height + header_height + 16}px)`;
}

class QuickAddToCart extends HTMLElement {
  constructor() {
    super()
    this.querySelector('form').onsubmit = (e) => {
      e.preventDefault()
    }
  }
}
customElements.define('quick-add-to-cart', QuickAddToCart);
